// Розкладка тексту на пачці — чисті функції, щоб їх можна було перевірити
// тестами без DOM. Малює пачку фронтенд (PackArt).
const NAME_LINE_LIMIT = 14;
const NOTES_LINE_LIMIT = 30;
// Назва великими літерами в 1–2 рядки: якщо не влазить в один, ділимо по межі
// слова так, щоб довший із двох рядків був найкоротшим. `shrink` — зменшити шрифт.
export function wrapPackName(name) {
    const words = name.trim().toUpperCase().split(/\s+/).filter(Boolean);
    const full = words.join(' ');
    if (words.length <= 1 || full.length <= NAME_LINE_LIMIT) {
        return { lines: [full], shrink: full.length > NAME_LINE_LIMIT };
    }
    let best = [words[0] ?? '', words.slice(1).join(' ')];
    for (let split = 2; split < words.length; split++) {
        const candidate = [words.slice(0, split).join(' '), words.slice(split).join(' ')];
        const longest = (lines) => Math.max(...lines.map((line) => line.length));
        if (longest(candidate) < longest(best))
            best = candidate;
    }
    return { lines: best, shrink: best.some((line) => line.length > NAME_LINE_LIMIT) };
}
// Ноти «жасмин, лимон» → ['ЖАСМИН · ЛИМОН'], переносимо між нотами, до двох рядків.
export function packNotes(notes) {
    const items = notes
        .split(',')
        .map((item) => item.trim().toUpperCase())
        .filter(Boolean);
    const lines = [];
    for (const item of items) {
        const last = lines.at(-1);
        if (last !== undefined && `${last} · ${item}`.length <= NOTES_LINE_LIMIT) {
            lines[lines.length - 1] = `${last} · ${item}`;
        }
        else {
            lines.push(item);
        }
    }
    return lines.slice(0, 2);
}
